import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { map, switchMap, catchError } from "rxjs/operators";

import {
  FETCH_POIS,
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAIL,
} from "../../constants";

const fetchPOIs = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_POIS),
    switchMap((action) => {
      const fullUrl = `${state$.value.auth.server}/admin/organizations/${action.organizationId}/pois`;
      console.log('Fetching POIs from:', fullUrl);

      return ajax({
        url: fullUrl,
        headers: {
          Authorization: `Bearer ${state$.value.auth.LIPToken}`,
        },
        responseType: "json",
        crossDomain: true,
        method: "GET",
      }).pipe(
        map((response) => {
          console.log('POIs API Response:', response);
          return {
            type: FETCH_POIS_SUCCESS,
            data: response.response,
          };
        }),
        catchError((error) => {
          console.error('POIs API Error:', error);
          return [{
            type: FETCH_POIS_FAIL,
            error: error
          }];
        })
      );
    }),
  );

export default fetchPOIs;

